/** Shared layout classes for viewport-centered modals (upper-center, scrollable body, footer at bottom). */

export const MODAL_OVERLAY_CENTERED =
    'fixed inset-0 z-[1050] flex items-start justify-center overflow-y-auto p-4 pt-[6vh] sm:pt-[8vh] pointer-events-none';

export const MODAL_DIALOG_SHELL =
    'pointer-events-auto flex w-full flex-col max-h-[min(85vh,900px)] overflow-hidden rounded-md bg-white shadow dark:bg-zink-600';

export const MODAL_BODY_SCROLL = 'min-h-0 flex-1 overflow-y-auto';

export const MODAL_FOOTER_PINNED =
    'mt-auto shrink-0 border-t border-slate-200 dark:border-zink-500';

export function mergeDialogClassName(dialogClassName?: string): string {
    return [MODAL_DIALOG_SHELL, dialogClassName].filter(Boolean).join(' ');
}

/** Legacy positioning classes from the old modal-center pattern — strip when migrating. */
export const LEGACY_MODAL_POSITION_CLASS =
    /(?:^|\s)fixed\s+left-2\/4(?:\s+|-translate-x-2\/4|-translate-y-2\/4|\s+z-\S+|\s+flex|\s+flex-col|\s+transition-all|\s+duration-300|\s+ease-in-out)+/g;

export function stripLegacyModalPositionClasses(className?: string): string {
    if (!className) return '';
    return className.replace(LEGACY_MODAL_POSITION_CLASS, '').replace(/\s+/g, ' ').trim();
}
